module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"select-carrier":"Select Carrier"}}')
  delete Component.options._Ctor
}
